var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgXLogo = function SvgXLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 42,
    viewBox: "0 0 42 42",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.94 18.7 34.54 6h-2.52l-9.2 11.03L15.47 6H7l11.11 16.68L7 36h2.51l9.72-11.65L26.99 36h8.47L23.94 18.7Zm-3.44 4.13-1.13-1.66-8.95-13.22h3.85l7.23 10.66 1.13 1.66 9.4 13.87h-3.86L20.5 22.83Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/x-logo.13c8b18dc7ac6ecbdd3213ca484f17b4.svg";